import React, { useState } from "react";
import FeatherIcon from "feather-icons-react";
import { ReactComponent as Logo } from "../logo/logo.svg";
import Actions from "../common/Actions";
import SubMenu from "./SubMenu";
import ActionDropDown from "./ActionDropDown";
import { useAppState } from "../../context/appContex";
import { IFilterData } from "../../@types/types";
import { getReleaseInfo, handleFilter } from "../../utils";
import GlobalSearch from "./GlobalSearch";
import SearchDropDown from "./SearchDropDown";

const Header: React.FC = () => {
  const [isDropDown, setIsDropDown] = useState(false);
  const [isUserDropDown, setIsUserDropDown] = useState(false);
  const [isGlobalSearch, setIsGlobalSearch] = useState(false);
  const [searchResult, setSearchResult] = useState<IFilterData>({
    quickLinks: [],
    mainItems: [],
  });
  const [searchValue, setSearchValue] = useState("");

  const { menuData, flatenedData, setMode, theme } = useAppState();

  const closeGlobalSearch = () => {
    setIsGlobalSearch(false);
    setSearchValue("");
    setSearchResult({
      quickLinks: [],
      mainItems: [],
    });
  };

  const openGlobalSearch = () => {
    setIsDropDown(false);
    setIsUserDropDown(false);
    setIsGlobalSearch(true);
  };

  const switchTheme = () => {
    const newMode = theme === "light" ? "dark" : "light";

    setMode(newMode);
  };

  const handleSearch = (searchValue: string) => {
    setSearchValue(searchValue);
    const result = handleFilter(flatenedData, searchValue);

    // console.log("result", result);

    setSearchResult(result);
  };

  return (
    <header className='header'>
      {isGlobalSearch ? (
        <GlobalSearch
          handleSearch={handleSearch}
          closeGlobalSearch={closeGlobalSearch}
        />
      ) : (
        <div className='header-content'>
          <div className='left'>
            <div
              className={isDropDown ? "menu active" : "menu"}
              onClick={() => {
                setIsDropDown((prev) => !prev);
                if (isUserDropDown) {
                  setIsUserDropDown(false);
                }
              }}
            >
              <FeatherIcon icon='menu' />
            </div>
            <span
              style={{
                margin: 0,
                padding: 0,
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => {
                if (menuData?.system.homeMenuItem.targetUrl) {
                  window.location.href =
                    menuData?.system.homeMenuItem.targetUrl;
                }
              }}
            >
              <Logo />
            </span>
          </div>
          <div
            className='right'
            style={{ display: "flex", alignItems: "center" }}
          >
            <small style={{ marginRight: "15px", opacity: 0.7 }}>
              v. {getReleaseInfo()}
            </small>
            <FeatherIcon
              icon={theme === "dark" ? "sun" : "moon"}
              style={{ cursor: "pointer", marginRight: "15px" }}
              onClick={switchTheme}
            />
            <Actions
              toggleDropDown={() => {
                setIsUserDropDown((prev) => !prev);
                if (isDropDown) {
                  setIsDropDown(false);
                }
              }}
              openSearch={openGlobalSearch}
              isSearch
              isSamll
            />
          </div>
        </div>
      )}
      {isDropDown && <SubMenu />}
      {isUserDropDown && <ActionDropDown />}
      {isGlobalSearch && (
        <SearchDropDown searchResult={searchResult} searchValue={searchValue} />
      )}
    </header>
  );
};

export default Header;
